// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"287":"core-roles","483":"issue-tracker-tasks","497":"core-users"}[chunkId] + "." + {"287":"c1cb057a","483":"b1a3643b","497":"496aa199"}[chunkId] + ".css";
};